import { createTheme } from '@mantine/core'
import { bluedotPrimaryColors, designGrayColors, designGreenColors, designRedColors } from './mantine.colors'
import { mantineComponents } from './mantine.components'
import { fontSizes } from './mantine.fonts'

export const theme = createTheme({
  cursorType: 'pointer',
  fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  fontSizes,
  primaryColor: 'violet',
  primaryShade: 6,
  colors: {
    'bluedot-primary': bluedotPrimaryColors,
    // Override default Mantine colors with design colors
    'green': designGreenColors,
    'gray': designGrayColors,
    'red': designRedColors,
    'violet': bluedotPrimaryColors,
  },
  components: mantineComponents,
})
